module.exports = __WEBPACK_EXTERNAL_MODULE_39__;


/*****************
 ** WEBPACK FOOTER
 ** external "moment"
 ** module id = 39
 ** module chunks = 0
 **/